export const routePaths = {
    account: '/account',
    categories: '/categories',
    categoriesCreate: '/categories/create',
    categoriesUpdate: '/categories/:id',
    cashFlow: '/cashFlow',
    dashboard: '/dashbord',
    employee: '/employees',
    employeeCreate: '/employees/create',
    employeeUpdate: '/employees/:id',
    login: '/login',
    products: '/products',
    productsCreate: '/products/create',
    productsUpdate: '/products/:id',
    discounts: '/discounts',
    discountsCreate: '/discounts/create',
    discountsUpdate: '/discounts/:id',
    ingredients: '/ingredients',
    statistics: '/statistics',
    tableMap: '/table',
    bills: '/bills',
    billsDetail: '/bills/:id',
    orders: '/orders',
    ordersDetail: '/orders/:id',
    warehouse: '/warehouse',
    warehouses: '/warehouse/list',
    warehousesCreate: '/warehouse/list/create',
    warehousesUpdate: '/warehouse/list/:id',
    warehouseCards: '/warehouse/cards',
    warehouseCardsCreate: '/warehouse/cards/create',
    warehouseCardsUpdate: '/warehouse/cards/:id',
    warehouseCardsWriteOff: '/warehouse/cards/write-off',
    warehouseCategories: '/warehouse/categories',
    warehouseCategoriesCreate: '/warehouse/categories/create',
    warehouseCategoriesUpdate: '/warehouse/categories/:id',
    inventoryCounts: '/warehouse/counts',
    inventoryCountsDetail: '/warehouse/counts/:id',
    currentInventoryCount: '/warehouse/counts/current-inventory-count',
    warehouseDeliveryLists: '/warehouse/delivery-lists',
    warehouseDeliveryListsCreate: '/warehouse/delivery-lists/create',
    warehouseDeliveryListsUpload: '/warehouse/delivery-lists/upload',
    warehouseDeliveryListsVerify: '/warehouse/delivery-lists/verify/:id',
    warehouseDeliveryListsDetails: '/warehouse/delivery-lists/:id',
    warehouseDeductionLists: '/warehouse/deduction-lists',
    warehouseDeductionListsDetails: '/warehouse/deduction-lists/:id',
    settings: '/settings',
    customPaymentMethodsSettings: '/settings/customPaymentMethods',
    customPaymentMethodsSettingsCreate: '/settings/customPaymentMethods/create',
    customPaymentMethodsSettingsUpdate: '/settings/customPaymentMethods/:id',
    reports: '/reports',
    reportsExpenses: '/reports/expenses',
    reportsProducts: '/reports/products',
    reportsCategories: '/reports/categories',
    reportsTables: '/reports/tables',
};

export enum Method {
    CREATE = '/create',
    UPDATE = '/update',
}

export type RoutePathsType = typeof routePaths;
export type RoutePathsKeys = keyof RoutePathsType;
export type RoutePathsValues = RoutePathsType[RoutePathsKeys];
